<div id="wrapper">
  <ng-content></ng-content>
</div>
